import Maths3 from "oc-threejs/Maths3";
import Griff from "./Griff";
import Brett from "./Brett";
import Schubladenbox from "./Schubladenbox";

export default class Schublade {
    // DO NOT CHANGE
    className = "Schublade";

    schubladenbox: Schubladenbox;

    // Die Bretter des Schublade sind im lokalen Koordinatensystem der Schubladenbox
    inner: Brett;
    front: Brett;
    griff: Griff;
    isTop = false;
    isBottom = false;

    get parent() {
        return this.schubladenbox;
    }

    constructor(schubladenbox) {
        this.schubladenbox = schubladenbox;
        this.inner = new Brett(this.schubladenbox, null, 'xy');
        this.front = new Brett(this.schubladenbox, this.schubladenbox.product.Artikelnummer, 'xy');
        this.griff = this.schubladenbox.hasGriffe ? new Griff(this.schubladenbox) : null;
        /* this.front.wireframe = true; */
    }

    compile() {
        this.inner.compile();
    }

    compileFront() {
        this.front.compile();

        if (this.schubladenbox.hasGriffe) {
            const griffProduct = APP.findProduct(this.griff.artikelnummer);
            this.griff.position.copy(this.front.box.grid(0.5, 1.0, 0.5));
            this.griff.position.y -= this.schubladenbox.schrank.options.getFloat('schublade_griffabstand_oben') || 0;
            this.griff.position.z = this.front.box.max.z;
            this.griff.quaternion.copy(griffProduct.DontRotate90 ? Maths3.quaternion.z90 : Maths3.quaternion.zero);
            this.griff.compile();
        }
    }

    get element() {
        return this.schubladenbox.element;
    }

    get bodenTop() {
        return this.isTop ? this.schubladenbox.boden.top : null;
    }

    get bodenBottom() {
        return this.isBottom ? this.schubladenbox.boden.bottom : null;
    }


    iterate(iterator) {
        iterator(this);
        this.inner && iterator(this.inner);
        this.front && iterator(this.front);
        this.griff && iterator(this.griff);
    }


}
